import HttpFactory from '~/repository/factory'
import type { IcatuLogDetail, IcatuLogsQuery, IcatuLogsPaginated } from '~/types/icatu-logs'

export class IcatuLogsModule extends HttpFactory {
  /**
   * Lista resumida (sem corpos). `signal` cancela a requisição anterior quando
   * o admin muda o filtro antes de a resposta chegar (AR-574 RN06).
   */
  list(query: IcatuLogsQuery = {}, opts: { signal?: AbortSignal } = {}): Promise<IcatuLogsPaginated> {
    return this.get('/icatu-api-logs', { query, signal: opts.signal })
  }

  /** Detalhe com `request`/`response` decifrados sob demanda (AR-574 RN02). */
  detail(id: string): Promise<IcatuLogDetail> {
    return this.get(`/icatu-api-logs/${encodeURIComponent(id)}`)
  }
}
